import { render, staticRenderFns } from "./questionAnswerNode.vue?vue&type=template&id=03babb28&scoped=true"
import script from "./questionAnswerNode.vue?vue&type=script&lang=js"
export * from "./questionAnswerNode.vue?vue&type=script&lang=js"
import style0 from "./questionAnswerNode.vue?vue&type=style&index=0&id=03babb28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03babb28",
  null
  
)

export default component.exports